import { apiFetch, apiRequest } from './client';
export async function getReportTemplates() {
    return await apiFetch('/reports/templates');
}
export async function saveTemplate(template, opts) {
    if (!opts.isNew) {
        await apiRequest('PUT', `/reports/templates/${template.id}`, template);
        return template;
    }
    const target = opts.scope ?? { scope: 'personal' };
    const result = await apiRequest('POST', '/reports/templates', {
        ...template,
        scope: target.scope,
        clinicId: target.clinicId,
        groupId: target.groupId,
    });
    return {
        ...template,
        id: result.id,
        ownerType: target.scope,
        clinicId: target.clinicId ?? null,
        groupId: target.groupId ?? null,
    };
}
export async function deleteReportTemplate(templateId) {
    await apiRequest('DELETE', `/reports/templates/${templateId}`);
}
export async function promoteReportTemplate(templateId, target) {
    return await apiRequest('POST', `/reports/templates/${templateId}/promote`, target);
}
// ============ Starter gallery ============
export async function getReportTemplateGallery() {
    return await apiFetch('/reports/templates/gallery');
}
export async function importGalleryTemplate(body) {
    return await apiRequest('POST', '/reports/templates/gallery/import', body);
}
export async function getReportPresets() {
    return await apiFetch('/reports/presets');
}
/** Saving under an existing name updates that preset (server-side upsert). */
export async function saveReportPreset(name, content) {
    return await apiRequest('POST', '/reports/presets', { name, content });
}
export async function deleteReportPreset(presetId) {
    await apiRequest('DELETE', `/reports/presets/${presetId}`);
}
// ============ Macros ============
export async function getReportMacros() {
    return await apiFetch('/reports/macros');
}
export async function createReportMacro(macro) {
    return await apiRequest('POST', '/reports/macros', macro);
}
export async function updateReportMacro(macroId, macro) {
    await apiRequest('PUT', `/reports/macros/${macroId}`, macro);
}
export async function deleteReportMacro(macroId) {
    await apiRequest('DELETE', `/reports/macros/${macroId}`);
}
